module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/restaurant_suc_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("支付成功")]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow suc-btn",
    on: {
      "click": _vm.toOrderDetail
    }
  }, [_vm._v("查看订单")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0278fe99","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/PaySuccess.vue
// module id = 406
// module chunks = 7